export const clientId = process.env.REACT_APP_AD_CLIENTID;
export const redirectUri = process.env.REACT_APP_ENV;
export const scopes = [process.env.REACT_APP_AD_SCOPEID];
export const authority = process.env.REACT_APP_AD_TENANTID;
